/** */
import { ADD_BALLANCE } from '../actions/payment';

export default (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_BALLANCE:
      return {
        balance: payload
      };
    default:
      return state;
  }
};
